var ytplayer = document.querySelector('#youtubeplayer');

if (ytplayer) {
    // 2. This code loads the IFrame Player API code asynchronously.
    var tag = document.createElement('script');

    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    // 3. This function creates an <iframe> (and YouTube player)
    //    after the API code downloads.
    var player;
    window.onYouTubeIframeAPIReady = function () {
        player = new YT.Player('youtubeplayer', {
            height: '600px',
            width: '100%',
            videoId: '',
            playerVars: {
                'controls': 0,
                'fs': 0,
                'showinfo': 0,
                'modestbranding': 1,
                'rel': 0,
                'autoplay': 0
            },
            events: {
                'onReady': onPlayerReady,
                'onStateChange': onPlayerStateChange
            }
        });
    }


    // 4. The API will call this function when the video player is ready.
    function onPlayerReady(event) {


        var ytplayerModal = document.querySelector('.modal-youtubeplayer');
        let modalBtns = document.querySelectorAll(".btn--playvideo");

        let i;

        for (let i = 0; i < modalBtns.length; i++) {
            // const modalHref = modalBtns[i].dataset.modalHref;
            const modalID = modalBtns[i].dataset.modalId;
            // const modalType = modalBtns[i].dataset.modalType;
            modalBtns[i].addEventListener('click', function (e) {
                e.preventDefault();
                videoModal(modalID)
            })
        }
        function videoModal(mID) {
            ytplayerModal.classList.add('open');
            ytplayerModal.querySelector('.modal-dialog').classList.add('open');
            player.loadVideoById(mID);
            player.playVideo()
            closeVideoModal()
        };
        if ( window.CookieInformation.getConsentGivenFor('cookie_cat_statistic') == false && ( document.getElementsByTagName("html")[0].getAttribute("lang") == "da-DK" || document.getElementsByTagName("html")[0].getAttribute("lang") == "nn-NO" || document.getElementsByTagName("html")[0].getAttribute("lang") == "sv-SE") )
        {
            document.querySelector('.modal-youtubeplayer .modal-dialog').innerHTML = window.CookieInformation.youtubeNotVisibleDescription;
        }
        //event.target.playVideo();
    }

    // 5. The API calls this function when the player's state changes.
    //    The function indicates that when playing a video (state=1),
    //    the player should play for six seconds and then stop.
    var done = false;
    function onPlayerStateChange(event) {
        // if (event.data == YT.PlayerState.PLAYING && !done) {
        //     setTimeout(stopVideo, 6000);
        //     done = true;
        // }
    }
    function stopVideo() {
        player.stopVideo();
    }

    var videoModalInner = document.querySelector('.modal-youtubeplayer .modal-dialog');
    var videoModalInnerParent = document.querySelector('.modal-youtubeplayer.open');
    var modalTrigger = document.querySelector('[data-modal="show-modal-video"]');
    

    function closeVideoModal(e) {
        document.addEventListener('click', function (e) {
            if (e.target == document.querySelector('.modal-youtubeplayer.open')) {
                var videoModalParent = document.querySelector('.modal-youtubeplayer');
                player.stopVideo()
                videoModalParent.classList.remove('open')
                videoModalParent.querySelector('.modal-dialog').classList.remove('open')
            }
        });
    }
}







// WEBPACK FOOTER //
// ./scripts/components/video.js